import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EResultsActionType } from './types';

export const setSubdomain = actionGenerator<EResultsActionType.SetSubdomain, string>(EResultsActionType.SetSubdomain);
